import { render, staticRenderFns } from "./LinksReport.vue?vue&type=template&id=2f270a98&scoped=true"
import script from "./LinksReport.vue?vue&type=script&lang=ts"
export * from "./LinksReport.vue?vue&type=script&lang=ts"
import style0 from "./LinksReport.vue?vue&type=style&index=0&id=2f270a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f270a98",
  null
  
)

export default component.exports